module.exports = __webpack_public_path__ + "static/media/hajj-package-3.03182983.jpg";